import moment from "moment";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getImportExportLogs } from "../../api";
import Loader from "../../component/Loader";
import Select from "react-select";

function ImportExportLogs() {
  const navigate = useNavigate();
  const authState = useSelector((store) => store.auth);
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(0);
  
  const isSuperAdmin = authState?.admin_type === 'super admin';

  let companyOptions = [];
  const companiesStr = localStorage.getItem('companies');
  if (companiesStr) {
    try {
      const companies = JSON.parse(companiesStr);
      companyOptions = [
        { value: 0, label: 'All Companies' },
        ...companies.map(company => ({
          value: company.id,
          label: company.company_name
        }))
      ];
    } catch (e) {
      console.error('Error parsing companies:', e);
    }
  }

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const company_id = selectedCompany > 0 ? selectedCompany : null;
      const response = await getImportExportLogs(company_id);
      if (response?.code === 1) {
        setLogs(response?.data?.list || []);
      } else {
        toast.error(response?.message || 'Failed to fetch logs');
      }
    } catch (error) {
      console.error('Error fetching logs:', error);
      toast.error('Failed to fetch logs');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isSuperAdmin) {
      fetchLogs();
    } else {
      toast.error('Access denied. Super admin only.');
      navigate('/import-export-data/user');
    }
  }, [selectedCompany]);

  const getActionTypeLabel = (actionType) => {
    const labels = {
      'import': 'Import',
      'export': 'Export',
      'request': 'Export Request',
      'approve': 'Approve Request',
      'deny': 'Deny Request'
    };
    return labels[actionType] || actionType;
  };

  const getStatusBadge = (status) => {
    const badges = {
      'completed': 'badge bg-success',
      'pending': 'badge bg-warning',
      'failed': 'badge bg-danger'
    };
    return badges[status] || 'badge bg-secondary';
  };

  return (
    <article className="col-lg-9 articleClass">
      <div className="article-body store-bd-gy">
        <div className="row align-items-center col-rever">
          <div className="col-sm-12 col-md-6 col-lg-6 mb-3">
            <div className="link-active shadow">
              <p>
                <img src="assets/images/event-calender-selected.png" alt="" />{" "}
                Import/Export Logs ({logs.length})
              </p>
            </div>
          </div>
          <div className="col-sm-12 col-md-6 col-lg-6 mb-3">
            <div className="d-flex align-items-center lg-justify-content-end">
              {Array.isArray(companyOptions) && companyOptions.length > 0 && (
                <div style={{ minWidth: '250px' }}>
                  <Select
                    options={companyOptions}
                    isSearchable
                    placeholder="Filter by company..."
                    value={companyOptions.find(opt => opt.value === selectedCompany)}
                    onChange={option => {
                      setSelectedCompany(option.value);
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-sm-9 col-md-9 col-lg-10">
            <ul
              className="nav nav-pills group-nav mb-3"
              id="pills-tab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="pills-new-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-new"
                  type="button"
                  role="tab"
                  aria-controls="pills-new"
                  aria-selected="false"
                  onClick={() => {
                    navigate("/import-export-data/user");
                  }}
                >
                  Users
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="pills-completed-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-completed"
                  type="button"
                  role="tab"
                  aria-controls="pills-completed"
                  aria-selected="false"
                  onClick={() => {
                    navigate("/import-export-data/student");
                  }}
                >
                  Students
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="pills-requests-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-requests"
                  type="button"
                  role="tab"
                  aria-controls="pills-requests"
                  aria-selected="false"
                  onClick={() => {
                    navigate("/import-export-data/requests");
                  }}
                >
                  Export Requests
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="pills-logs-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-logs"
                  type="button"
                  role="tab"
                  aria-controls="pills-logs"
                  aria-selected="true"
                >
                  Logs
                </button>
              </li>
            </ul>
          </div>
          <div className="col-sm-12">
            <div className="table-responsive text-center">
              <table className="table storetable">
                <thead className="text-center">
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Date & Time</th>
                    <th scope="col">Admin</th>
                    <th scope="col">Company</th>
                    <th scope="col">Type</th>
                    <th scope="col">Action</th>
                    <th scope="col">User Role</th>
                    <th scope="col">File Type</th>
                    <th scope="col">Records</th>
                    <th scope="col">Status</th>
                    <th scope="col">Details</th>
                  </tr>
                  <tr className="border-0 bg-none invisible">
                    <td className="border-0 bg-none"></td>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan={11}>
                        <Loader />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {logs?.length > 0 ? (
                        logs?.map((log, i) => {
                          return (
                            <tr key={i}>
                              <td>{log?.id || "NA"}</td>
                              <td>
                                {log?.createdAt
                                  ? moment(log?.createdAt).format("DD MMM YYYY, hh:mm A")
                                  : "NA"}
                              </td>
                              <td>
                                {log?.admin?.name || "NA"}
                                <br />
                                <small className="text-muted">{log?.admin?.email || ""}</small>
                              </td>
                              <td>{log?.company?.company_name || "NA"}</td>
                              <td className="text-capitalize">{log?.type || "NA"}</td>
                              <td>{getActionTypeLabel(log?.action_type)}</td>
                              <td className="text-capitalize">
                                {log?.user_role?.replace('_', ' ') || "NA"}
                              </td>
                              <td className="text-uppercase">{log?.file_type || "NA"}</td>
                              <td>{log?.records_processed || 0}</td>
                              <td>
                                <span className={getStatusBadge(log?.status)}>
                                  {log?.status || "NA"}
                                </span>
                              </td>
                              <td>
                                <small>{log?.details || "NA"}</small>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={11}>
                            <div className="text-center py-4">
                              <p className="text-muted">No logs found</p>
                            </div>
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}

export default ImportExportLogs;
